import React from "react"

const SpeakingModule = () => (
    <section class="lrws-section-1">
        <div class="container">
        <div class="listening-wrapper mt-5">
              <div class="row">
                <div class="col-md-4">
                  <div class="listening-image-wrapper">
                    <img src={require('../../images/speaking-image.png')} alt="" />
                  </div>
                </div>
                <div class="col-md-8" >
                  <div class="listening-content-wrapper">
                    <h3 class="content-title">
                     Speaking
                    </h3>
                    <ul>
                      <li>
                        <span>
                          <img src={require('../../images/duration.png')} alt="" />
                          <strong>Duration: : </strong> 60 min  (4-5 min, 2 min & 4-5 min)
                        </span>
                      </li>
                    </ul>
                    <p className="note">The speaking part has three tasks</p>
                    <div class="listening-sections-wrapper">
                      <p class="content-sub-title">Sections</p>
                      <div class="content-sections">
                        <div>Task 1</div>
                        <p>General questions about yourself and familiar topics, such as home, family, work,studies and interests. Lasts for about 4-5 minutes.</p>
                      </div>
                      <div class="content-sections">
                        <div>Task 2</div>
                        <p>Talk about the given topic. You get one minute for preparation and will speak for up to two minutes. A few questions will be asked on the topic.</p>
                      </div>
                      <div class="content-sections">
                        <div>Task 3</div>
                        <p>More questions on the topic in task 2. You will be able to discuss abstract ideas and issues in depth. Lasts for about 4-5 minutes.</p>
                      </div>
                    </div>
                    <div class="d-flex align-items-center mt-5">
                      <button class="trymock-btn">TRY MOCK TEST</button>
                      <div class="free-label">FREE!</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
)

export default SpeakingModule
